import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import { configure, menuSelect } from 'instantsearch.js/es/widgets';
import map from './algolia/mapWidget';

const appId = wlAlgolia.application_id;
const apiKey = wlAlgolia.search_api_key;
const indexName = wlAlgolia.indices.searchable_posts.name;

// Instantiate instantsearch.js
const search = instantsearch({
  searchClient: algoliasearch(appId, apiKey),
  indexName,
  initialUiState: {
    refinementList: {
      post_type_label: [
        'Pages',
        'Press Releases',
        'In the News',
        'Articles',
        'Can-Do Journal',
        'Events'
      ]
    }
  }
});

// Configuration
search.addWidget(
  configure({
    hitsPerPage: 100,
    facetingAfterDistinct: true,
    disjunctiveFacets: ['post_type_label'],
    facets: ['post_has_location'],
    facetsRefinements: {
      post_has_location: [true]
    }
  })
);

// Add menuSelect widget
search.addWidget(
  menuSelect({
    container: '#algolia-menu-select',
    attribute: 'taxonomies.post_tag',
    limit: 10,
    cssClasses: {
      root: 'ais-menu-select--narrow'
    },
    templates: {
      defaultOption: 'Filter by Use'
    }
  })
);

// Add map widget
search.addWidget(
  map({
    container: '#algolia-map'
  })
);

// Start search
search.start();
